// Which rows of an export a run reads. Kept apart from ingest_core.js,
// which needs Node, so the Ingest screen can say how many rows of a file
// it is about to upload are new.

// Select the rows a run should process, and the run mode. Backfill (empty
// watermark) honours the connector's optional `backfillUntil` cutoff — rows with
// timestampColumn ≤ cutoff, holding a later tranche back; without a cutoff it takes
// everything. Incremental (watermark set) ignores the cutoff entirely and takes
// rows newer than the watermark, so a plain re-run picks the held-back tranche up.
// After the mapping changed (`rereadAll`), every row is read again, so the
// records already in the Pod are rewritten with it.
export function selectPending(rows, connector) {
  const { lastRun, backfillUntil } = connector;
  // Some exports are snapshots with a stable key but no timestamp (Casa in
  // the normalized CTL contract). Re-project every row on each run: record
  // URLs derive from that key, so the PUTs are idempotent without pretending
  // that a label or row number is a watermark.
  if (!connector.timestampColumn) return { mode: 'snapshot', pending: rows };
  const timestampColumn = connector.timestampColumn;
  if (lastRun) {
    return { mode: 'incremental', pending: connector.rereadAll ? rows : rows.filter((r) => r[timestampColumn] > lastRun) };
  }
  const pending = backfillUntil ? rows.filter((r) => r[timestampColumn] <= backfillUntil) : rows;
  return { mode: 'backfill', pending };
}
